import AccessLevels from "Areas/SharedFeatures/accessLevels";
import AccessLevelsCreatorPanel from "Areas/SharedFeatures/accessLevelsCreatorPanel";
import AccessLevelsEditorPanel from "Areas/SharedFeatures/accessLevelsEditorPanel";
import TaskStatistics from "Areas/SharedFeatures/taskStatistics";
import TasksTable from "Areas/SharedFeatures/tasksTable";
import { WITH_APP_PAGE_BODY_SIZES_CLASS_NAME } from "Common/componentUtils/constants";
import { ACCESS_LEVEL_ENTITY } from "Common/dictionaries/accessLevelEntity";
import Menu from "Components/menu";
import ProgressOverlay from "Components/progressOverlay";
import { Tab, TabPanel, Tabs } from "Components/tabs";
import classNames from "classnames";
import compact from "lodash/compact";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo } from "react";
import { useResizeDetector } from "react-resize-detector";
import ProjectList from "./projectList";
import locale from "./workSpaceDetails.locale";
import Button from "Components/button";
import styles from "./workSpaceDetails.module.css";
export default function WorkSpaceDetails(props) {
    var _a, _b, _c, _d, _e, _f;
    const { height, ref: tabContentObservableRef } = useResizeDetector();
    const { width, ref: rightPanelObservableRef } = useResizeDetector();
    useEffect(() => {
        props.workSpaceId && props.onInitialized && props.onInitialized(props.workSpaceId);
    }, [props.workSpaceId]);
    useEffect(() => {
        props.workSpaceId && props.onInitialized && props.onInitialized(props.workSpaceId);
    }, []);
    const tabs = useMemo(() => compact([
        props.canViewProjects && {
            id: 1,
            title: locale.PROJECTS,
            render: () => { var _a; return React.createElement(ProjectList, { data: (_a = props.data) === null || _a === void 0 ? void 0 : _a.Projects }); }
        },
        props.canViewTasks && {
            id: 2,
            title: locale.TASKS,
            render: () => React.createElement(TasksTable, { workspaceId: props.workSpaceId })
        },
        props.canViewTasks && {
            id: 3,
            title: locale.TASK_STATISTICS,
            render: () => React.createElement(TaskStatistics, { workSpaceId: props.workSpaceId })
        }
    ]), [props.data, props.workSpaceId, props.canViewProjects, props.canViewTasks]);
    const menuItems = useMemo(() => compact([
        props.canEditWorkSpaces && {
            text: locale.MANAGE_ACCESS,
            onClick: () => {
                props.onOpenAccessLevelsEditorPanel &&
                    props.workSpaceId &&
                    props.onOpenAccessLevelsEditorPanel(props.workSpaceId);
            }
        },
        props.canEditWorkSpaces && {
            divider: true
        },
        props.canEditWorkSpaces && {
            text: locale.EDIT_WORK_SPACE,
            onClick: () => {
                var _a;
                props.onOpenWorkSpaceEditorPanel &&
                    props.data &&
                    props.onOpenWorkSpaceEditorPanel((_a = props.data) === null || _a === void 0 ? void 0 : _a.Id);
            }
        },
        props.canDeleteWorkSpaces && {
            text: locale.DELETE_WORK_SPACE,
            confirm: {
                title: locale.CONFIRM_DELETE_WORK_SPACE_TEXT,
                header: locale.CONFIRM_DELETE_WORK_SPACE_HEADER,
                callback: () => {
                    var _a;
                    ((_a = props.data) === null || _a === void 0 ? void 0 : _a.Id) && props.onDeleteWorkSpace && props.onDeleteWorkSpace(props.data.Id);
                }
            }
        }
    ]), [props.data, props.canEditWorkSpaces, props.canDeleteWorkSpaces]);
    const tabData = useMemo(() => {
        var _a;
        return ((_a = props.data) === null || _a === void 0 ? void 0 : _a.Projects)
            ? locale.buildCountProjectsTitle(props.data.Projects.length)
            : locale.buildCountProjectsTitle(0);
    }, [props.data, props.workSpaceId, props.canViewProjects, props.canViewTasks, props.tab]);
    const handleCreateProject = useCallback(() => {
        props.workSpaceId &&
            props.onOpenProjectCreatorPanel &&
            props.onOpenProjectCreatorPanel(props.workSpaceId);
    }, [props.workSpaceId, props.onOpenProjectCreatorPanel]);
    return (React.createElement(ProgressOverlay, { show: props.inProgress }, props.data ? (React.createElement("div", { className: classNames("grid-rows-auto-1fr", WITH_APP_PAGE_BODY_SIZES_CLASS_NAME) },
        React.createElement("div", null,
            React.createElement("div", { className: classNames("grid-cols-1fr-auto", styles.header) },
                React.createElement("div", { className: "overflow-hidden" },
                    React.createElement("div", { className: styles.title },
                        React.createElement("h2", { title: (_a = props.data) === null || _a === void 0 ? void 0 : _a.Name, className: classNames("text-overflow-ellipsis nowrap", styles.name) }, ((_b = props.data) === null || _b === void 0 ? void 0 : _b.Name) || ""),
                        tabData && (React.createElement("div", { className: classNames("w-fit-content", styles["tab-data"]) }, tabData))),
                    React.createElement("div", { title: (_c = props.data) === null || _c === void 0 ? void 0 : _c.Description, className: "text-muted text-overflow-ellipsis nowrap" }, ((_d = props.data) === null || _d === void 0 ? void 0 : _d.Description) || "")),
                React.createElement("div", { className: styles.actions },
                    props.canEditProjects && (React.createElement(Button, { text: locale.CREATE_PROJECT, onClick: handleCreateProject, className: "btn-primary btn-with-icon", icon: "add", height: "36px" })),
                    !isEmpty(menuItems) && (React.createElement(Menu, { togglerClassName: "menu-toggle-btn-border", togglerIconClassName: "icon-dots menu-toggle-btn-border-icon", items: menuItems, togglerHeight: "36px", togglerWidth: "36px" }))))),
        tabs.length > 0 && props.workSpaceId && (React.createElement("div", { className: "d-flex justify-content-space-between panel-body-pb overflow-hidden", ref: tabContentObservableRef },
            React.createElement(Tabs, { className: classNames("w-100 with-gap-20", styles.tabs), onTabChange: props.onChangeTab, selectedTabIndex: props.tab, rightPanelWidth: width ? width + 15 : 0, flex: true, useGap: false }, map(tabs, item => {
                var _a;
                return [
                    React.createElement(Tab, { title: item.title, key: `tab-${item.id}`, rightPanel: props.canEditWorkSpaces ? (React.createElement("div", { ref: rightPanelObservableRef },
                            React.createElement(AccessLevels, { openedHeight: height, defaultOpen: props.tab === 0, entityId: props.workSpaceId, entityType: ACCESS_LEVEL_ENTITY.WORKSPACE, userCreate: (_a = props.data) === null || _a === void 0 ? void 0 : _a.UserCreated }))) : undefined }),
                    React.createElement(TabPanel, { key: `tab-panel-${item.id}`, className: classNames(tabs.length > 0 && props.workSpaceId ? "ml-gap mr-gap" : "panel-body-padding") }, item.render ? item.render() : React.createElement("div", null))
                ];
            })),
            props.canEditWorkSpaces && (React.createElement(AccessLevelsEditorPanel, { entityId: props.workSpaceId, entityType: ACCESS_LEVEL_ENTITY.WORKSPACE, userCreate: (_e = props.data) === null || _e === void 0 ? void 0 : _e.UserCreated })),
            props.canEditWorkSpaces && (React.createElement(AccessLevelsCreatorPanel, { entityId: props.workSpaceId, entityType: ACCESS_LEVEL_ENTITY.WORKSPACE, userCreate: (_f = props.data) === null || _f === void 0 ? void 0 : _f.UserCreated })))))) : (React.createElement("div", null))));
}
